export default __webpack_public_path__ + "static/ghostB-b97219d5f1e26c9354f7049d6fdfc628.svg";